<template>
    <el-card>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">Inicio</el-breadcrumb-item>
            <span class="el-breadcrumb__item">
                <span role="link" class="el-breadcrumb__inner is-link" @click="cleanReport">Proyectos</span>
                <span role="presentation" class="el-breadcrumb__separator">/</span>
            </span>
            <span class="el-breadcrumb__item " v-if="name"><span role="link" class="el-breadcrumb__inner color-primary">Proyecto {{ name }}</span></span>
        </el-breadcrumb>

		<div class="loading" v-if="loading" v-loading="loading"></div>
		<template v-if="!loading">
            <el-row type="flex" align="stretch">
                <el-col :span="7"  :class="(viewReports ? 'separador' : false)" >
                    <app-table-paginate
                        :routeEdit="'modal'"
                        :routeDelete="(currentUser.rol == 1 ? true : false)"
                        :routeView="false"
                        :routeSelect="true"
                        :tableQuery="tableData"
                        :tableColumns="headers"
                        :multipleSelect="false"
                        :search="true">
                    </app-table-paginate>
                    <br>
                    <button v-if="currentUser.rol == 1" type="primary" form="a"  @click="newProject()" class="el-button el-button--primary el-button--medium"><span><i class="el-icon-circle-plus-outline"></i>Proyecto</span></button>
                    <el-button type="primary" size="medium" @click="nuevoRegistro()"> <i class="el-icon-circle-plus-outline"></i> Cuadro de mando</el-button>

                    <app-modal-new-project v-if="addNewProject" :project="project_id"></app-modal-new-project>
                </el-col>
                <el-col :span="17" :class="(viewReports ? 'bg--white' : false)">
                    <transition name="fade" mode="out-in" v-if="viewReports">
                        <app-informes  :project="viewReports"></app-informes>
                    </transition>
                </el-col>
            </el-row>
        </template>
    </el-card>
</template>

<script>
	import ApiService from '@/common/api.service'
    import tablaConPaginador from '@/components/Dashboard/commons/tablaConPaginador'
    import Informes from '@/components/Dashboard/InformesProyecto'
    import ModalProject from '@/components/Dashboard/Modals/addNewProject'
	import { mapGetters } from "vuex"
    import draggable from '@/components/Dashboard/Modals/draggable'

    export default {
        name: 'Proyectos',
        components: {
			'app-table-paginate': tablaConPaginador,
            'app-informes': Informes,
            'app-modal-new-project': ModalProject
        },
        computed: {
			...mapGetters(['isAdmin', 'currentUser'])
		},
        created () {
            this.viewReports == false ? window.localStorage.removeItem('analiticaproyectoActivo') : this.viewReport(this.viewReports, this.name) ;

            if(!this.isAdmin){
                this.$router.replace('/dashboard/misinformes')
            }
			this.$root.$on('closeModal', ()=> {
				this.addNewProject = false
				this.init()
            })
            setTimeout(() => {
                this.init()
            }, 100);

			this.$root.$on('select', (id, row) => this.viewReport(id, row.proyecto))

			this.$root.$on('openModal', (id)=> {
                this.project_id = id
                setTimeout(() => {
                    this.addProject()
                }, 500);
            })

            this.$root.$on('delete', (id) => this.eliminarRegistro(id) )

        },
        data () {
            return  {
				loading: true,
				headers: [
                {
                    'prop': 'proyecto',
                    'label': 'Proyecto'
                }],
				field: {},
				tableQuery: {},
				relationship: [],
				routeEdit: null,
                deleterow: false,
                viewReports: false,
                addNewProject: false,
                project_id: null,
                name: false
            }
        },
        watch: {
			$route(to) {
                this.viewReports = false
				this.loading = true
				this.tableQuery = {}
				this.headers = []
				this.routeEdit = '/dashboard/form/informe/'
				this.init()
			}
		},
        methods: {
			init() {
                this.loading = true
				this.getTableData()
            },
            viewReport(id, name) {
                this.viewReports = false
                this.$root.$emit('sidebar', id);
                setTimeout(() => {
                    this.viewReports = id
                    this.name = name
                }, 500);
            },
            cleanReport(){
                this.viewReports = false
                this.name = false
            },
            addProject(){
                this.addNewProject = true
            },
            newProject(){
                this.$root.$emit('isConnect')
                this.project_id = null
                setTimeout(() => { this.addNewProject = true}, 100);
            },
            nuevoRegistro() {
                this.$root.$emit('isConnect')
                this.$router.push('/dashboard/form/informe/')
            },
            async getTableData() {
                let data;

                if(this.currentUser.rol == 1 ){
                    data = {
                        token: localStorage.getItem("analiticatoken"),
                        single: false,
                        method: 'select',
                        fields: ['proyectos.id', 'proyectos.proyecto'],
                        table: 'proyectos',
                        order: [' proyectos.proyecto ASC'],
                    }
                }else if(this.currentUser.rol == 3) {
                    data = {
                        token: localStorage.getItem("analiticatoken"),
                        single: false,
                        method: 'select',
                        fields: ['proyectos.id', 'proyectos.proyecto'],
                        inner: [
                            'users_projects, project_id, id, proyectos',
                        ],
                        table: 'proyectos',
                        order: [' proyectos.proyecto ASC'],
                        where: ' users_projects.user_id = ' + this.currentUser.id,
                    }
                }

                ApiService.post("public/v1", data).then(response => {
                    if(response.data == 'Algo ha fallado'){
                        this.tableData = []
                    }else{
	    				let a = [{
                            id:'0',
                            proyecto: 'Informes sin asignar'
                        }]
                        this.tableData = a.concat(response.data)
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 200);
                })
            },
            async eliminarRegistro (id){
                this.loading = true
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    method: 'DELETE',
                    id: id ,
                    table: 'proyectos',
                }).then(response => {
                    if(response.data == 1){
                        this.$root.$emit('msgSuccess', 'Registro ELIMINADO')
                        setTimeout(() => {
                            this.init()
                        }, 1000);
                    }else{
                        // this.$root.$emit('msgError', 'Algo ha fallado')
                    }
                })
            }
        }
    }
</script>

<style>
    .el-breadcrumb__inner {
        font-size: 18px;
    }
    .color-primary {
        color: #8f0ced !important;
    }
    .separador {
        padding-right: 1%;
        border-right: 2px solid #eeeeee;
        margin-right: 1%;
    }
    .bg--white {
        background: #ffffff;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Proyectos.vue